import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { computed, ref, toRef, watch } from "vue";
import WorkflowIcons from "@/components/Workflow/icons";
import { useWorkflowStores } from "@/composables/workflowStores";
import { useRefreshFromStore } from "@/stores/refreshFromStore";
import { useStepProps } from "../composables/useStepProps";
import { useUniqueLabelError } from "../composables/useUniqueLabelError";
import FormConditional from "./FormConditional.vue";
import FormCard from "@/components/Form/FormCard.vue";
import FormDisplay from "@/components/Form/FormDisplay.vue";
import FormElement from "@/components/Form/FormElement.vue";
import FormOutputLabel from "@/components/Workflow/Editor/Forms/FormOutputLabel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'FormDefault',
    props: {
        step: null,
        datatypes: null
    },
    emits: [
        "onAnnotation",
        "onLabel",
        "onAttemptRefactor",
        "onEditSubworkflow",
        "onSetData",
        "onUpdateStep",
    ],
    setup(__props, { emit }) {
        const props = __props;
        const stepRef = toRef(props, "step");
        const { stepId, contentId, annotation, label, name, type, configForm } = useStepProps(stepRef);
        const { stepStore } = useWorkflowStores();
        const uniqueErrorLabel = useUniqueLabelError(stepStore, label.value);
        const stepTitle = computed(() => {
            if (isSubworkflow.value) {
                return name.value;
            }
            else {
                return contentId?.value || name.value;
            }
        });
        const nodeIcon = computed(() => WorkflowIcons[type.value]);
        const formDisplayId = computed(() => stepId.value.toString());
        const isSubworkflow = computed(() => type.value === "subworkflow");
        function onAnnotation(newAnnotation) {
            emit("onAnnotation", stepId.value, newAnnotation);
        }
        function onLabel(newLabel) {
            emit("onLabel", stepId.value, newLabel);
        }
        function onEditSubworkflow() {
            emit("onEditSubworkflow", contentId.value);
        }
        function onUpgradeSubworkflow() {
            emit("onAttemptRefactor", [{ action_type: "upgrade_subworkflow", step: { order_index: stepId.value } }]);
        }
        // keeps the component from emitting the onCreate change event
        const initialChange = ref(true);
        function onChange(values) {
            if (!initialChange.value) {
                emit("onSetData", stepId.value, {
                    id: stepId.value,
                    type: type.value,
                    content_id: contentId.value,
                    inputs: values,
                });
            }
            initialChange.value = false;
        }
        const { formKey } = storeToRefs(useRefreshFromStore());
        watch(() => formKey.value, () => (initialChange.value = true));
        return { __sfc: true, props, emit, stepRef, stepId, contentId, annotation, label, name, type, configForm, stepStore, uniqueErrorLabel, stepTitle, nodeIcon, formDisplayId, isSubworkflow, onAnnotation, onLabel, onEditSubworkflow, onUpgradeSubworkflow, initialChange, onChange, formKey, FormConditional, FormCard, FormDisplay, FormElement, FormOutputLabel };
    }
});
